import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const getMessagingContentRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_CMS_MESSAGING_CONTENT,
        params: params,
    });
};


export const getMessagingSearchRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_CMS_MESSAGING_SEARCH,
        params: params,
    });
};

export const postMessagingContentRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.POST_CMS_MESSAGING_CONTENT,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const putMessagingContentRepo = (id,data) => {
    return axios({
      method: 'PUT',
      url: Urls.PUT_CMS_MESSAGING_CONTENT + id + '/',
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    })
  }
  
  export const deleteMessagingContentRepo  = (id, data) => {
    return axios({
      method: 'DELETE',
      url: Urls.PUT_CMS_MESSAGING_CONTENT + id + '/',
      data: data
    })
  }

  